import React from 'react';
import { Typography, Container, Box, Grid2 } from '@mui/material';
import FooterLinks from './FooterLinks';

function Footer() {

  const usefulLinks = [
    { text: "Informations", href: "/#information" },
    { text: "Théâtre", href: "/#theatre" },
    { text: "Film", href: "/#film" },
    { text: "Télévision", href: "/#television" },
  ];

  const socialLinks = [
    { text: "Mail", href: 'mailto:Jocelyne.jbj@gmail.com' },
  ];

  return (
    <Box
      component="footer"
      sx={{
        background: "#000000",
        color: "#ffffff",
        pt: 4,
        pb: 2,
      }}
    >
      <Container maxWidth="lg">
        <Grid2 container spacing={4} justifyContent="center">
          <Grid2 xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ fontFamily: 'Josefin Sans' }}>
              JOCELYNE JEAN-BAPTISTE
            </Typography>
            {/* link to the email */}
            <Typography variant="body2" sx={{ fontFamily: 'Josefin Sans', marginTop: "1rem" }}>
              <a href="mailto:Jocelyne.jbj@gmail.com">
                Jocelyne.jbj@gmail.com
              </a>
            </Typography>
          </Grid2>

          <Grid2 xs={12} md={4}>
            <FooterLinks title="Liens" links={usefulLinks} />
          </Grid2>

          <Grid2 xs={12} md={4}>
            <FooterLinks title="Contact" links={socialLinks} />
          </Grid2>
        </Grid2>

        <Typography
          variant="body2"
          color="#ffffff"
          align="center"
          sx={{ mt: 4, fontFamily: 'Josefin Sans' }}
        >
          Jocelyne Jean-Baptiste {new Date().getFullYear()}
          {'.'}
        </Typography>
      </Container>
    </Box>
  );
}

export default Footer;
